import { apiUrl } from "@/utils/helpers";
import axios from "axios";

const path = "/api/createcourse/verifyoffer";

export const verifyOffer = async ({
  channelId,
  planId,
  code,
}: {
  planId?: string;
  channelId: string;
  code: string;
}) => {
  const { data } = await axios.post<{
    data: {
      discounted_price?: number;
      discount_percentage?: number;
      view?: string;
    };
  }>(apiUrl(path), {
    channelID: channelId,
    offer: code,
    plan_id: planId,
  });

  return data;
};

export const VERIFY_OFFER_KEY = `VERIFY_OFFER`;
